export default function VideosIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 19 19" fill="none">
      <path
        d="M12.3228 9.0345C12.7302 9.27418 12.7302 9.82546 12.3228 10.0412L8.10433 12.462C7.72084 12.6777 7.26544 12.414 7.26544 11.9586V6.97321C7.26544 6.54178 7.72084 6.27813 8.10433 6.46987L12.3228 9.0345ZM15.5106 9.46593C15.5106 12.7496 12.8501 15.4101 9.56641 15.4101C6.28273 15.4101 3.62223 12.7496 3.62223 9.46593C3.62223 6.18225 6.28273 3.52175 9.56641 3.52175C12.8501 3.52175 15.5106 6.18225 15.5106 9.46593ZM4.77272 9.46593C4.77272 12.1264 6.90591 14.2596 9.56641 14.2596C12.2029 14.2596 14.3601 12.1264 14.3601 9.46593C14.3601 6.8294 12.2029 4.67224 9.56641 4.67224C6.90591 4.67224 4.77272 6.8294 4.77272 9.46593Z"
        fill="currentColor"
      />
    </svg>
  );
}
